

























































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import LocationDto from "@/models/Locations/LocationDto";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { CompanyDetailsModule } from "@/store/modules/companyDetails";
import { ContactDetailsModule } from "@/store/modules/contactDetails";
import CreateContactLocationRequest from "@/models/ContactLocations/CreateContactLocationRequest";
// @ts-ignore

//import { VueTelInputVuetify } from 'vue-tel-input-vuetify';

@Component({
  name: "ContactLocationCreate",
})
export default class extends GiganautVueDialog {

public entity = new LocationDto();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new LocationDto();
      await ContactDetailsModule.getCompanyLocations();
    }
  }

  get locations() {
    return ContactDetailsModule.companyLocations;
  }

  get loading() {
    return ContactDetailsModule.loadingDialog;
  }

  async save() {
    const request = new CreateContactLocationRequest();
    request.locationId = this.entity.id;
    await ContactDetailsModule.createContactLocation(request);
    this.dialog = false;
  }
}
